module.exports = __webpack_public_path__ + "img/details1.f27271ae.png";